import { render } from "./Ghost.vue?vue&type=template&id=7d0f1435&scoped=true"
import script from "./Ghost.vue?vue&type=script&lang=js"
export * from "./Ghost.vue?vue&type=script&lang=js"

import "./Ghost.vue?vue&type=style&index=0&id=7d0f1435&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0f1435"]])

export default __exports__